import { Container } from 'inversify';

export const dependencyContainer: Container = new Container();
